import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button } from "@material-ui/core";
import style from "./FileExplorerModal.module.css";
import axios from "axios";

const FileExplorerModal = (props) => {
    const [folders, setFolders] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [selectedIcon, setSelectedIcon] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const imgUrl = window.location.origin + "/feature_icons/";

    const fetchFolders = async () => {
        try {
            const response = await axios.get("/manager/data/feature_icons/");
            setFolders((pr) => [...response.data]);
        } catch (error) {
            console.error(error);
        }
    };

    const nandleDrop = async () => {
        const formData = new FormData();
        formData.append("image", props.featName);

        try {
            const response = await axios.post(
                "/manager/data/drop_img",
                formData,
            );
            handleRefresh();
            props.setFeatName(null);
            setSelectedIcon(null);
            alert("Файл удален");
        } catch (error) {
            console.error(error);
        }
    };

    const uploadImages = async (files) => {
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append(`images[${i}]`, files[i]);
        }
        formData.append("directory", selectedFolder?.folderName);

        try {
            const response = await axios.post(
                "/manager/data/upload_img",
                formData,
            );

            if (!response.data.result) {
                if (response?.data?.validator) {
                    const errorMessages = Object.keys(
                        response.data.validator,
                    ).map((key) => {
                        const errors = response.data.validator[key];
                        const formattedErrors = errors.join("\n");
                        return `${key}: \n${formattedErrors}`;
                    });
                    alert(errorMessages.join("\n"));
                }
            } else if (response.data.result) {
                handleRefresh();
                alert("Иконки успешно загружены");
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchFolders();
    }, [refresh]);

    useEffect(() => {
        let selectedIndex;
        if (folders.length > 0) {
            if (selectedFolder) {
                selectedIndex = folders.findIndex(
                    (f) => f.folderName === selectedFolder.folderName,
                );
            } else {
                selectedIndex = 0;
            }
            setSelectedFolder((prev) => folders[selectedIndex]);
        }
    }, [folders]);

    const handleFolderClick = (folder) => {
        setSelectedFolder(folder);
        setSelectedIcon(null);
    };

    const handleIconClick = (icon) => {
        setSelectedIcon(icon);
        props.updateImage("icon", `${selectedFolder.folderName}/${icon}`);
        props.setFeatName(`${selectedFolder.folderName}/${icon}`);
    };

    const nandleClose = () => {
        if (!selectedIcon) {
            alert("Вы не выбрали иконку");
            return;
        }
        props.setFeatModalVisible(false);
    };

    const handleFileUpload = (event) => {
        const files = event.target.files;

        if (files.length > 0) {
            uploadImages(files);
        }
    };

    const handleRefresh = () => {
        setRefresh((pr) => !pr);
    };

    return (
        <Dialog
            open={props.featModalVisible}
            onClose={nandleClose}
            fullWidth
            maxWidth="xl"
        >
            <DialogTitle>Выбор иконки</DialogTitle>
            <DialogContent>
                <div className={style.folders}>
                    {folders.map((folder) => (
                        <div
                            className={
                                folder?.folderName == selectedFolder?.folderName
                                    ? style.selected__folder
                                    : style.folder
                            }
                            key={folder.folderName}
                            onClick={() => handleFolderClick(folder)}
                        >
                            {folder.folderName}
                        </div>
                    ))}
                </div>

                {selectedFolder && (
                    <div>
                        <h3>{selectedFolder.folderName}</h3>
                        <div className={style.features}>
                            {selectedFolder.icons.map((icon) => (
                                <div
                                    className={style.icon__el}
                                    key={icon}
                                    onClick={() => handleIconClick(icon)}
                                >
                                    <img
                                        className={
                                            selectedIcon != null &&
                                            selectedIcon == icon
                                                ? style.selected__icon
                                                : style.icon
                                        }
                                        src={`${imgUrl}${encodeURIComponent(selectedFolder.folderName)}/${icon}`}
                                        alt={icon}
                                    />
                                    <div>{icon}</div>
                                </div>
                            ))}
                        </div>
                        <div>
                            <label className={style.uploadButton}>
                                Загрузить файлы
                                <input
                                    type="file"
                                    multiple
                                    onChange={handleFileUpload}
                                />
                            </label>
                        </div>
                    </div>
                )}

                {selectedIcon && (
                    <div className={style.current__icon}>
                        <h3>Выбранная Иконка</h3>
                        <img
                            className={style.icon}
                            src={`${imgUrl}${encodeURIComponent(props.featName)}`}
                            alt={selectedIcon}
                        />
                        <div>{props.featName}</div>
                        <Button
                            style={{ backgroundColor: "red", marginTop: "5px" }}
                            variant="contained"
                            color="primary"
                            onClick={nandleDrop}
                        >
                            Удалить этот файл
                        </Button>
                    </div>
                )}
                <div className={style.button__ok}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={nandleClose}
                    >
                        Ок
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default FileExplorerModal;
